import {NgModule, Component, Input} from '@angular/core';

@Component({
	selector: 'tags',
	templateUrl:'tags.template.html',
    styleUrls:['tags.style.scss']                
})
export class Tags {
    @Input() items: any;

    ngOnInit(){
    }
}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/tags/tags.component.ts